import { Accordion } from "@/components/ui-library-new/accordion/Accordion"
import { AccordionItem } from "@/components/ui-library-new/accordion/AccordionItem"
import { IconCircle } from "@/components/ui-library-new/icon/IconCircle"
import Richtext from "@/components/ui-library/richtext/Richtext"
import { BlokProps } from "@/helpers/StoryblokHelpers"
import { FaqSectionStoryblok } from "@/types/component-types"
import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc"

export const FaqSection = ({ blok }: BlokProps<FaqSectionStoryblok>) => {
  const { title, items } = blok

  return (
    <section
      {...storyblokEditable(blok as SbBlokData)}
      className="flex flex-col gap-6 bg-surface py-[18px] lg:gap-8 lg:py-10"
    >
      <div className="mx-auto w-full max-w-[1155px] scroll-mt-32 px-4 lg:px-8">
        <h2 className="mb-6 text-[18px] font-extrabold text-neutral-90 lg:text-2xl">{title}</h2>

        <Accordion type="single" collapsible>
          {items.map(item => (
            <AccordionItem
              key={item._uid}
              value={item._uid}
              title={item.question}
              titleSize="lg"
              icon={
                <IconCircle
                  className="h-10 w-10 lg:h-16 lg:w-16 2xl:h-[70px] 2xl:w-[70px]"
                  iconClassName="h-5 w-5 lg:h-8 lg:w-8"
                  icon={item.icon}
                />
              }
            >
              <Richtext className="text-[#6B6F67]" content={item.answer} bodySmall={true} />
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  )
}
